import {forEachNode, qa} from "./dom-utils.js";

const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
var autofillHandledCounter = 0;

export function checkIsDecoy(input) {
    return input.classList.contains('autofill-decoy')
}

function refillSelf(input) {
    const t = input.value
    input.value = ""
    setTimeout(() => {
        input.value = t
    }, 50)
}

function refillFromDecoy(input) {
    const t = input.value
    input.value = ""
    const target = byId(input.dataset.targetInputId)
    if (!target) { return }
    setTimeout(() => {
        target.dispatchEvent(new Event('input-synth', { target: target }))
        target.value = t
    }, 50)
}

function refillInput(autoFilled) {
    ++autofillHandledCounter
    const isDecoy = checkIsDecoy(autoFilled)
    if (isDecoy) {
        refillFromDecoy(autoFilled)
    } else {
        refillSelf(autoFilled)
    }
}

export function initGracefulAutofill() {
    if (!isChrome) { return }
    var iterations = 0
    const intId = setInterval(() => {
        console.debug('GracefulAutofillMonitor : ping')
        if ((++iterations > 20000) || (autofillHandledCounter > 10)) {
            clearInterval(intId)
        }
        const autofilled = qa(':-webkit-autofill')
        forEachNode(autofilled, refillInput)
    }, 30)
}